import { utils } from "ethers";

export const shortenAddress = (address = "", skipShort?: boolean): string => {
  if (!address) {
    return "";
  }
  address = utils.getAddress(address);
  if (skipShort) {
    return address;
  }
  return `${address.substr(0, 6)}...${address.substr(-6)}`;
};
